namespace('compass.demographic');

compass.demographic.CategorySelectWidget = compass.defineWidget(function CategorySelectWidget(options) {
	var me = this;
	var $j = jQuery;
	var _settings = options;
	var _WUID = _settings.WUID;

	var _drawAsSelect = (_settings.categories.length > 2) || 
		($j.inArray(true, _.map(_settings.categories, function(item){return item.password;})) !== -1);

	var _setupControls = this.setupControls = function() {
		me.find('.clicker').activate(function() {
			me.trigger("CategorySelect.categoryClicked", {
				categoryId : me.find('.categoryDropDownSelect').val()
			});
		});
	};

	var _render = this.render = function(widgetElem) {
		var d = _d;
		
		// :FORCED ERRROR: - for greping
		if ( window.location.href.indexOf("?throwAWidgetError") > 0 ){ var a = variable.that.doesnt.exist; }

		// :FORCED ERRROR: - for greping
		if ( window.location.href.indexOf("?throwAResizeObserverError") > 0 ){
			window.setTimeout(function(){

				const createAndAppendElement = (tagName, parent) => {
			        if (!parent) {
			            parent = document.body;
			        }
			        const element = document.createElement(tagName);
			        parent.appendChild(element);
			        return element;
				};

			    const t1 = createAndAppendElement("div");
			    const t2 = createAndAppendElement("div", t1);

			    const observer = new ResizeObserver((entries) => {
			    	t2.style.width = (Math.floor(Math.random() * 1200)) + "px";
				});

			    const observer2 = new ResizeObserver((entries) => {
			    	t1.style.width = (Math.floor(Math.random() * 1200)) + "px";
				});

			    observer.observe(t1);
			    observer2.observe(t2);
			},500);
			}
		
		widgetElem.append(
			d.reader( d.h2('Select category and view hotels or log in to existing record') ),
			d.div(
				_drawAsSelect ? me.drawCategoryAsDropDown() : me.drawCategoriesAsButtons()
			)
		);
		
		_setupControls();
	};

	function _categorySelectHandler(data) {
		return function(e) {
			var categoryClickedObj = { categoryId : data.categoryId, name : data.name };
			if (me.find('input[type="password"].password').length > 0 && data.password) {
				var password =  me.find('input[type="password"].password').val();
				categoryClickedObj.password = password;
			}
			me.trigger("CategorySelect.categoryClicked", categoryClickedObj);
		};
	}

	this.drawCategoriesAsButtons = function() {
		var d = _d;
		return _.map(_settings.categories, function(item) {
			return d.button({ className : 'categoryDiv button', role : 'button', 'aria-role' : 'button', tabindex : 0 },
			d.div({ className : 'categoryName' }, item.name)).activate(_categorySelectHandler(item));
		});
	};

	this.drawCategoryAsDropDown = function() {
		var d = _d;

		var dropDownSelectCategories = [{
			categoryId: -1,
			name: 'Choose a category',
			password: false
		}];

		$j.map(_settings.categories, function(item, index) {
			dropDownSelectCategories.push({
				categoryId : item.categoryId,
				name: item.name,
				password: item.password
			});
		});

		var categoryChanged = function(data) {
			var category = me.find('.categorySelectButton');
			if (data.categoryId != -1) {
				category.removeClass('disabled').addClass('enabled');
				category.deactivate();
				category.activate(_categorySelectHandler(data));
			}
			else {
				category.removeClass('enabled').addClass('disabled');
				category.deactivate();
			}

			data.password ? me.find('.passwordHolder').show().focus() : me.find('.passwordHolder').hide();
			me.find('.passwordMessage').empty();
		};

		return d.div({
			className : 'categoryDropDown',
			role : 'form'
		}, d.dataSelect({
			data : dropDownSelectCategories,
			className : 'categorySelect',
			change : categoryChanged,
			labelMapper : function(data) { return data.name; },
			choiceMapper : function(data) { return data.name; },
			classMapper : function(data) {
				return data.categoryId.toString()+" "+(data.password ? 'categoryPassword' : 'noCategoryPassword');
			},
			idGenerator : compass.generateId
		}),
		d.div({
			className : 'passwordHolder'
		}, d.div({
			className : 'passwordMessage'
		}), d.input({
			className : 'password',
			name : 'password',
			type : 'password',
			placeholder : 'Password',
			'aria-label' : 'Password'
		})).hide(),
		d.button({ className : 'categorySelectButton button disabled', role : 'button', 'aria-role' : 'button', tabindex : 0 }, 'View Hotels'));
	};
	var _d = jQuery.dom.getContext(this);

}, {
	WUID : 'defaultCategorySelectWidgetWUID',
	widgetName : 'CategorySelectWidget'
});
